// extracted by mini-css-extract-plugin
module.exports = {"blockClick":"SegmentsDetails_blockClick_1v281"};